import { ButtonBase } from '@material-ui/core';

import styled from 'styled-components';

export const ButtonInputAdorment = styled(ButtonBase)<{ width?: string }>`
  width: ${props => props.width || '215px'};
  display: flex;
  justify-content: end;
`;
